import { useCallback } from 'react'

import { ProductUnitSelect } from '@features/products/elements/ProductUnitSelect'

import { useInvoiceEditorForm } from '../../../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { CommonInvoiceLineFieldProps } from '../../../../../../types/commonInvoiceLineFieldProps'

type InvoiceLineUnitProps = CommonInvoiceLineFieldProps

export const InvoiceLineUnit = ({ disabled = false, lineIndex }: InvoiceLineUnitProps) => {
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const { FormItem } = invoiceEditorForm

  const handleDropdownOpen = useCallback(() => {
    trackInvoiceEditor('Form - Invoice lines - Unit dropdown opened')
  }, [trackInvoiceEditor])

  return (
    <FormItem
      name={`invoiceLines.${lineIndex}.unit`}
      render={({ field: { onChange, ...field } }) => {
        return (
          <ProductUnitSelect
            {...field}
            disabled={disabled}
            onSelect={(value) => {
              onChange(value)

              if (value) {
                trackInvoiceEditor('Form - Invoice lines - Unit selected', {
                  option: value,
                })
              }
            }}
            onDropdownOpen={handleDropdownOpen}
            selectLook={false}
            size="sm"
          />
        )
      }}
    />
  )
}
